package uz.ferro.erp.feature.user.model

import kotlinx.serialization.Serializable

@Serializable
data class UserDto(
    val id: Long?,
    val name: String? = null,
    val username: String? = null,
    val password: String? = null,
    val role: Role? = null,
    val disabled: Boolean? = null,
)


